import "@sphtech/dmg-design-system/dist/theme-hw.css";
import "@sphtech/dmg-design-system/assets/hw/fonts.css";

import Newsticker from "@components/Modules/Newsticker/Newsticker";
import { configSite } from "@pub/config";
import { BaseLayout, CustomClassContext } from "@sphtech/dmg-design-system";
import cx from "classnames";
import { useLocation } from "react-router";

import { configHeader } from "./config/configHeader";
import customStyle from "./custom.module.css";
import logoSvgSource from "./logo.svg?raw";
import { RoutePaths } from "./routePaths";

type HWBaseLayoutProps = {
  ArticleTitle?: string;
  children: React.ReactNode;
  ads?: boolean;
  leaderboard?: boolean;
  skipMobileBanner?: boolean;
};

/**
 * Reusable Base layout specific to HW.
 */
const HWBaseLayout = ({
  ArticleTitle,
  children,
  ads = true,
  leaderboard = true,
  skipMobileBanner,
}: HWBaseLayoutProps) => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  return (
    <CustomClassContext.Provider
      value={{
        categoryLayout: {
          sectionContainer: cx(
            location.pathname === "/events" &&
              customStyle["eventsSectionContainer"],
          ),
        },
        navbar: {
          primaryItems: customStyle["primaryItemsContainer"],
        },
        contentHubLayout: {
          userSubmissionBox: customStyle["userSubmission"],
        },
      }}
    >
      <BaseLayout
        ArticleTitle={ArticleTitle}
        ads={ads}
        leaderboard={leaderboard}
        NewsTicker={<Newsticker />}
        RoutePaths={RoutePaths}
        svgSource={logoSvgSource}
        siteName={configSite.name}
        mciText={
          <span suppressHydrationWarning>
            MDDI (P) 044/11/2024. Published by SPH Media Limited, Co. Regn. No.
            202120748H. Copyright © {currentYear} SPH Media Limited. All rights
            reserved.
          </span>
        }
        socialIconProps={configHeader.socialMedia}
        megaMenuProps={{
          NewsLetterProps: configHeader.megaMenu.newsletter,
          CloseButtonProps: configHeader.megaMenu.closeButton,
        }}
        currentLocation={location}
        skipMobileBanner={skipMobileBanner}
      >
        {children}
      </BaseLayout>
    </CustomClassContext.Provider>
  );
};

export default HWBaseLayout;
